module.exports = __webpack_public_path__ + "assets/img/jtfx62.50c00954.jpg";